// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"205":"post","636":"landing","846":"writer","966":"login"}[chunkId] + "." + {"205":"0de0766a","636":"8c4c7ce3","846":"229b9a6c","966":"ed699ef7"}[chunkId] + ".js";
};